module.exports = __webpack_public_path__ + "media/img/illustrations/wallet-ed29ccf37ffc7e109c48a66391f99783.svg";